;(function () {
  'use strict'
  $(document).on('change', '.datatable-filter [data-filter="select"]', function () {
    window.renderedDataTable.ajax.reload(null, false)
  })

  $(document).on('input', '.dt-search', function () {
    window.renderedDataTable.ajax.reload(null, false)
  })

  const confirmSwal = async (message) => {
    return await Swal.fire({
      title: message,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#858482',
      confirmButtonText: 'Yes, do it!'
    }).then((result) => {
      return result
    })
  }

  window.confirmSwal = confirmSwal

  $('#quick-action-form').on('submit', function (e) {
    e.preventDefault()
    const form = $(this)
    const url = form.attr('action')
    const message = $('[name="message_' + $('[name="action_type"]').val() + '"]').val()
    const rowdIds = $('#datatable_wrapper .select-table-row:checked')
      .map(function () {
        return $(this).val()
      })
      .get()
    confirmSwal(message).then((result) => {
      if (!result.isConfirmed) return
      callActionAjax({ url: `${url}?rowIds=${rowdIds}`, body: form.serialize() })
      //
    })
  })

  // Update status on switch
  $(document).on('change', '#datatable_wrapper .switch-status-change', function () {
    let url = $(this).attr('data-url')
    let body = {
      status: $(this).prop('checked') ? 1 : 0,
      _token: $(this).attr('data-token')
    }
    callActionAjax({ url: url, body: body })
  })

  $(document).on('change', '#datatable_wrapper .change-select', function (e) {
    let $select = $(this)
    
    // Skip if this is a programmatic change (reverting)
    if ($select.data('reverting')) {
      $select.data('reverting', false)
      return
    }
    
    let url = $select.attr('data-url')
    let selectedValue = $select.val()
    let previousValue = $select.data('previous-value') || $select.find('option:selected').data('initial-value') || $select.find('option:first').val()
    
    // If no actual change, return
    if (selectedValue === previousValue) {
      return
    }
    
    let body = {
      value: selectedValue,
      _token: $select.attr('data-token')
    }
    
    // Show confirmation dialog for booking status changes
    if (url && url.includes('update-status')) {
      const statusMap = {
        'pending': 'Pending',
        'confirmed': 'Confirmed',
        'check_in': 'Checked In',
        'check_out': 'Checked Out', 
        'completed': 'Completed',
        'cancelled': 'Cancelled',
        'rejected': 'Rejected'
      }
      
      const statusName = statusMap[selectedValue] || selectedValue
      
      Swal.fire({
        title: 'Confirm Status Change',
        text: `Are you sure you want to change the booking status to "${statusName}"?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, change it!'
      }).then((result) => {
        if (result.isConfirmed) {
          // Show loading notification
          Swal.fire({
            title: 'Updating...',
            text: 'Please wait while we update the booking status.',
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading()
            }
          })
          
          callActionAjax({ url: url, body: body, $select: $select })
        } else {
          // Revert to previous value if cancelled
          $select.data('reverting', true)
          $select.val(previousValue).trigger('change.select2')
        }
      })
    } else {
      // For non-status changes, proceed without confirmation
      callActionAjax({ url: url, body: body, $select: $select })
    }
  })

  function callActionAjax({ url, body, $select }) {
    $.ajax({
      type: 'POST',
      url: url,
      data: body,
      headers: {
        'X-CSRF-TOKEN': body._token || $('meta[name="csrf-token"]').attr('content')
      },
      success: function (res) {
        if (res.status) {
          // Enhanced notification for booking status changes
          if (url.includes('update-status')) {
            // Update the stored previous value on success
            if ($select) {
              $select.data('previous-value', body.value)
            }
            
            // Map status values to friendly names
            const statusMap = {
              'pending': 'Pending',
              'confirmed': 'Confirmed',
              'check_in': 'Checked In',
              'check_out': 'Checked Out', 
              'completed': 'Completed',
              'cancelled': 'Cancelled',
              'rejected': 'Rejected'
            }
            
            const statusName = statusMap[body.value] || body.value
            
            // Show success notification with custom message
            Swal.fire({
              icon: 'success',
              title: 'Status Updated!',
              text: `Booking status has been changed to "${statusName}"`,
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true
            })
          } else {
            // Default success notification for other actions
            window.successSnackbar(res.message)
          }
          
          window.renderedDataTable.ajax.reload(resetActionButtons, false)
          const event = new CustomEvent('update_quick_action', { detail: { value: true } })
          document.dispatchEvent(event)
        } else {
          // Close loading dialog
          Swal.close()
          
          // Show error and revert select if provided
          if ($select && url.includes('update-status')) {
            const previousValue = $select.data('previous-value') || $select.find('option:first').val()
            $select.data('reverting', true)
            $select.val(previousValue).trigger('change.select2')
          }
          
          Swal.fire({
            title: 'Error',
            text: res.message || 'Failed to update status',
            icon: 'error'
          })
        }
      },
      error: function(xhr, status, error) {
        // Close any loading dialogs
        Swal.close()
        
        // Revert select if provided
        if ($select && url.includes('update-status')) {
          const previousValue = $select.data('previous-value') || $select.find('option:first').val()
          $select.data('reverting', true)
          $select.val(previousValue).trigger('change.select2')
        }
        
        let errorMessage = 'Failed to update status. Please try again.'
        
        // Try to extract error message from response
        if (xhr.responseJSON && xhr.responseJSON.message) {
          errorMessage = xhr.responseJSON.message
        } else if (xhr.status === 419) {
          errorMessage = 'Session expired. Please refresh the page and try again.'
        } else if (xhr.status === 404) {
          errorMessage = 'The booking could not be found.'
        } else if (xhr.status === 500) {
          errorMessage = 'Server error. Please contact support if this persists.'
        }
        
        Swal.fire({
          title: 'Error',
          text: errorMessage,
          icon: 'error'
        })
      }
    })
  }

  // Update status on button click
  $(document).on('click', '#datatable_wrapper .button-status-change', function () {
    let url = $(this).attr('data-url')
    let body = {
      status: 1,
      _token: $(this).attr('data-token')
    }
    callActionAjax({ url: url, body: body })
  })

  //select row in datatable
  const dataTableRowCheck = (id) => {
    console.log(id)
    checkRow()
    if ($('.select-table-row:checked').length > 0) {
      $('#quick-action-form').removeClass('form-disabled')
      //if at-least one row is selected
      document.getElementById('select-all-table').indeterminate = true
      $('#quick-actions').find('input, textarea, button, select').removeAttr('disabled')
    } else {
      //if no row is selected
      document.getElementById('select-all-table').indeterminate = false
      $('#select-all-table').attr('checked', false)
      resetActionButtons()
    }

    if ($('#datatable-row-' + id).is(':checked')) {
      $('#row-' + id).addClass('table-active')
    } else {
      $('#row-' + id).removeClass('table-active')
    }
  }
  window.dataTableRowCheck = dataTableRowCheck

  const selectAllTable = (source) => {
    const checkboxes = document.getElementsByName('datatable_ids[]')
    for (var i = 0, n = checkboxes.length; i < n; i++) {
      // if disabled property is given to checkbox, it won't select particular checkbox.
      if (!$('#' + checkboxes[i].id).prop('disabled')) {
        checkboxes[i].checked = source.checked
      }
      if ($('#' + checkboxes[i].id).is(':checked')) {
        $('#' + checkboxes[i].id)
          .closest('tr')
          .addClass('table-active')
        $('#quick-actions').find('input, textarea, button, select').removeAttr('disabled')
        if ($('#quick-action-type').val() == '') {
          $('#quick-action-apply').attr('disabled', true)
        }
      } else {
        $('#' + checkboxes[i].id)
          .closest('tr')
          .removeClass('table-active')
        resetActionButtons()
      }
    }

    checkRow()
  }

  window.selectAllTable = selectAllTable

  const checkRow = () => {
    if ($('.select-table-row:checked').length > 0) {
      $('#quick-action-form').removeClass('form-disabled')
      $('#quick-action-apply').removeClass('btn-soft-primary').addClass('btn-primary')
    } else {
      $('#quick-action-form').addClass('form-disabled')
      $('#quick-action-apply').removeClass('btn-primary').addClass('btn-soft-primary')
    }
  }

  window.checkRow = checkRow

  //reset table action form elements
  const resetActionButtons = () => {
    checkRow()
    if (document.getElementById('select-all-table') !== undefined && document.getElementById('select-all-table') !== null) {
      document.getElementById('select-all-table').checked = false
      document.getElementById('select-all-table').indeterminate = false
      // $("#quick-action-form")[0].reset();
      $('#quick-actions').find('input, textarea, button, select').attr('disabled', 'disabled')
      $('#quick-action-form').find('select').select2('destroy').select2().val(null).trigger('change')
    }
  }

  window.resetActionButtons = resetActionButtons

  const initDatatable = ({ url, finalColumns, advanceFilter, drawCallback = undefined, orderColumn }) => {
    const data_table_limit = $('meta[name="data_table_limit"]').attr('content')

    // console.log("test",advanceFilter);
    window.renderedDataTable = $('#datatable').DataTable({
      processing: true,
      serverSide: true,
      autoWidth: false,
      responsive: true,
      fixedHeader: true,
      lengthMenu: [
        [5, 10, 15, 20, 25, 100, -1],
        [5, 10, 15, 20, 25, 100, 'All']
      ],
      pageLength: data_table_limit,
      order: orderColumn,
      dom: '<"row align-items-center"><"table-responsive my-3 mt-3 mb-2 pb-1" rt><"row align-items-center data_table_widgets" <"col-md-6" <"d-flex align-items-center flex-wrap gap-3" l i>><"col-md-6" p>><"clear">',
      ajax: {
        type: 'GET',
        url: url,
        data: function (d) {
          d.search = {
            value: $('.dt-search').val()
          }
          d.filter = {
            column_status: $('#column_status').val()
          }
          if (typeof advanceFilter == 'function' && advanceFilter() !== undefined) {
            d.filter = { ...d.filter, ...advanceFilter() }
          }
        }
      },

      drawCallback: function () {
        if (laravel !== undefined) {
          window.laravel.initialize()
        }
        $('.select2').select2()
        if (drawCallback !== undefined && typeof drawCallback == 'function') {
          drawCallback()
        }
      },
      columns: finalColumns
    })
  }

  window.initDatatable = initDatatable

  function formatCurrency(number, noOfDecimal, decimalSeparator, thousandSeparator, currencyPosition, currencySymbol) {
    // Convert the number to a string with the desired decimal places
    let formattedNumber = parseFloat(number).toFixed(noOfDecimal)

    // Split the number into integer and decimal parts
    let [integerPart, decimalPart] = formattedNumber.split('.')

    // Add thousand separators to the integer part
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator)

    // Set decimalPart to an empty string if it is undefined
    decimalPart = decimalPart || ''

    // Construct the final formatted currency string
    let currencyString = ''

    if (currencyPosition === 'left' || currencyPosition === 'left_with_space') {
      currencyString += currencySymbol
      if (currencyPosition === 'left_with_space') {
        currencyString += ' '
      }
      currencyString += integerPart
      // Add decimal part and decimal separator if applicable
      if (noOfDecimal > 0) {
        currencyString += decimalSeparator + decimalPart
      }
    }

    if (currencyPosition === 'right' || currencyPosition === 'right_with_space') {
      // Add decimal part and decimal separator if applicable
      if (noOfDecimal > 0) {
        currencyString += integerPart + decimalSeparator + decimalPart
      }
      if (currencyPosition === 'right_with_space') {
        currencyString += ' '
      }
      currencyString += currencySymbol
    }

    return currencyString
  }

  window.formatCurrency = formatCurrency
})()
